import { render, staticRenderFns } from "./ReturnItems.vue?vue&type=template&id=4aae6dcc&scoped=true&"
import script from "./ReturnItems.vue?vue&type=script&lang=js&"
export * from "./ReturnItems.vue?vue&type=script&lang=js&"
import style0 from "./ReturnItems.vue?vue&type=style&index=0&id=4aae6dcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aae6dcc",
  null
  
)

export default component.exports